var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1081 16.7143V9.97714C17.108 9.7704 17.0553 9.56671 16.9546 9.38332C16.8538 9.19992 16.7079 9.0422 16.5293 8.9235L10.3224 4.80857V3.85714H14.3938V0H8.96523V4.80857L2.75833 8.92414C2.57971 9.04274 2.43385 9.20035 2.3331 9.38363C2.23235 9.56692 2.17967 9.77049 2.17951 9.97714V16.7143H0.143799V18H19.1438V16.7143H17.1081ZM10.3224 1.28571H13.0367V2.57143H10.3224V1.28571ZM3.53666 9.97714L9.6438 5.92714L15.7509 9.97714V16.7143H10.3224V11.5714H8.96523V16.7143H3.53666V9.97714Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamp);
export default __webpack_public_path__ + "static/media/camp.246b9d25e0da1aa1203c8708e0c1d493.svg";
export { ForwardRef as ReactComponent };